import {createSelectOption} from '../../shared/select/select.option';

export default class ProductCheckController {
  /* @ngInject */
  constructor($translate, RouterService, ProductService, GeographyService, AuthService, MediaQueryService, BreadcrumbService, HttpService, $timeout) {
    this.productService = ProductService;
    this.geographyService = GeographyService;
    this.authService = AuthService;
    this.routerService = RouterService;
    this.mediaQueryService = MediaQueryService;
    this.breadcrumbService = BreadcrumbService;
    this.httpService = HttpService;
    this.translate = $translate;
    this.timeout = $timeout;
    this.onBreadcrumbClick = this.onBreadcrumbClick.bind(this);
  }

  $onInit() {
    this.loading = true;
    this.listenMediaQuery();
    this.timeout(() => this.initData());
  }

  initData() {
    const queryStringParams = this.routerService.location.search();
    const params = {sort: 'name', 'filter[regionIds]': [queryStringParams.regionId]};
    return this.geographyService.getMarkets({params}).then((data) => {
      const marketId = queryStringParams.marketId || data[0].id;
      this.markets = data;
      this.marketOptions = data.map(market => createSelectOption(market.id, market.name));
      this.marketSelected = this.marketOptions.find(m => m.value === marketId) || {};

      return this.getActiveStores(marketId);
    }).then(() => {
      return this.productService.get(this.routerService.state.params.id);
    }).then((product) => {
      this.product = product;
      this.breadcrumbs = this.createBreadcrumbs(product);
      return this._fetchDataTable(this.marketSelected.value);
    })
    .finally(() => {
      this.loading = false;
    });
  }

  getActiveStores(marketId) {
    this.activeStores = null;
    return this.geographyService.getActiveStores(marketId).then((activeStores) => {
      this.activeStores = activeStores;
      return activeStores;
    });
  }

  displayError({data} = {}) {
    this.errorMessage = this.productService.errorResponse(data);
    throw new Error(this.errorMessage);
  }

  onChangeMarketSelect(newMarket) {
    this.loading = true;
    this.stockData = null;
    this.errorMessage = false;
    this.getActiveStores(newMarket.value).then(() => this._fetchDataTable(newMarket.value));
  }

  _fetchDataTable(marketId) {
    this.loading = true;
    return this._fetchData(marketId)
      .then(([eCommerceStockList]) => {
        this.eCommerceStockList = eCommerceStockList;
        this.errorMessage = false;
      })
      .catch(err => this.displayError(err))
      .finally(() => this.loading = false);
  }

  _fetchData(marketId) {
    return this.httpService.all([
      this._shouldFetchStockEcommerce(marketId),
      this._fetchStock(marketId),
    ]);
  }

  _fetchStock(marketId) {
    return this.productService.getStockByMarketId(marketId, this.product.id).then((stockData) => {
      this.stockData = stockData;
      if (!this.stockData.length) {
        this.displayError();
      }
      return this.stockData;
    });
  }

  _shouldFetchStockEcommerce(marketId) {
    const market = this.markets.find(m => m.id === marketId);
    const hasOmnistock = !!market && market.hasOmnistock();
    const hasEcommerce = !!market && market.hasEcommerce();
    const emptyResponse = Promise.resolve({ecommerce: hasEcommerce ? [] : undefined, omnistock: hasOmnistock ? [] : undefined});
    if (!market) {
      return emptyResponse;
    }
    const storeId = market.getDefaultStoreForMarket();
    if (!storeId) {
      return emptyResponse;
    }
    const store = this.activeStores.find(s => s.id === storeId);
    if (!store) {
      return emptyResponse;
    }

    return Promise.all([
      hasEcommerce ? this.productService.eCommerceStock(this.product.id, store.locGrpOciEcommerce) : undefined,
      // checking hasOmnistock but using locGrpOciFull because FENDI wants locGrpOciFull value without changing omnistock label
      hasOmnistock ? this.productService.eCommerceStock(this.product.id, store.locGrpOciFull) : undefined,
    ])
      .then(res => ({ ecommerce: res[0], omnistock: res[1] }))
      .catch(console.log);
  }

  createBreadcrumbs(product) {
    return [
      {id: product.genderId, value: product.gender, filter: 'gender'},
      {id: product.categoryId, value: product.category, filter: 'category'},
      {label: product.getTranslatedName()},
      {label: this.translate.instant('PRODUCT.STOCK_CHECK')},
    ];
  }

  listenMediaQuery() {
    this.isTablet = this.mediaQueryService.is('tablet');
    this.mediaQueryService.on('tablet', match => this.isTablet = match);
    this.isDesktop = this.mediaQueryService.is('desktop');
    this.mediaQueryService.on('desktop', match => this.isDesktop = match);
  }

  onBreadcrumbClick(items, item) {
    const params = this.breadcrumbService.createFilterParams(items, item);
    this.routerService.state.go('products', params);
  }
}



// WEBPACK FOOTER //
// ./src/app/product/product-check/product-check.controller.js